<!-- BatchDeleteMemberAccountForm.vue -->
<script setup>
import { ref, computed } from "vue";
import { useManagedAccountStore } from "@/stores/useManagedAccountStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const emit = defineEmits(["close", "refresh", "notify"]);
const managedAccountStore = useManagedAccountStore();

const selectedCount = computed(
  () => managedAccountStore.selectedRelationshipIds.length,
);

// Congela a quantidade para o texto não mudar após o clique
const frozenCount = ref(0);

function freezeCount() {
  frozenCount.value = selectedCount.value;
}

const title = "Apagar/Revogar Vínculos em Lote";

const messageTitle = computed(() => {
  const n = frozenCount.value || selectedCount.value;

  if (n <= 1) {
    return "Você está prestes a apagar/revogar 1 vínculo selecionado.";
  }

  return `Você está prestes a apagar/revogar ${n} vínculos selecionados.`;
});

const messageSubtitle = "Esta ação não pode ser desfeita.";

const successMessage = computed(() => {
  const n = frozenCount.value || selectedCount.value;

  if (n <= 1) {
    return "Vínculo apagado/revogado com sucesso.";
  }

  return `${n} vínculos apagados/revogados com sucesso.`;
});

function buildErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro ao apagar/revogar os vínculos."
  );
}

async function onConfirm() {
  freezeCount();

  try {
    await managedAccountStore.bulkRevoke();

    emit("notify", {
      type: "success",
      message: successMessage.value,
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildErrorMessage(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    :title="title"
    :messageTitle="messageTitle"
    :messageSubtitle="messageSubtitle"
    confirmText="Sim, apagar/revogar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirm"
    :closeImmediatelyOnSuccess="true"
    @close="emit('close')"
  />
</template>
